// Dönüşüm olayları (GA4 → Google Ads içe aktarma: "Kaydolma", "Potansiyel müşteri").
// İzinler Consent Mode ile yönetilir: analitik/reklam izni yoksa gtag çerezsiz ping gönderir.
// Olaylara kişisel veri (ad, e-posta, telefon) eklenmez; yalnızca ürün bilgisi gider.

export const trackConversion = (name, params = {}) => {
  try {
    if (typeof window !== 'undefined' && typeof window.gtag === 'function') window.gtag('event', name, params);
  } catch {
    // gtag yüklenemediyse (reklam engelleyici vb.) akışı bozma
  }
};

// Hesabın etkinleştiği yere göre hangi ürün için kaydolduğu (dönüş adresinden)
export const signUpProduct = (returnTo) => {
  const p = String(returnTo || '');
  if (p.startsWith('/mulk-takibi')) return 'mulk_takibi';
  if (p.startsWith('/kiraci')) return 'kiraci_portali';
  return 'site';
};

export const trackSignUp = (returnTo) => trackConversion('sign_up', { method: 'odazen', product: signUpProduct(returnTo) });

export const trackLead = (product) => trackConversion('generate_lead', { product });

// İletişim formu gönderildi (yalnızca konu kodu; ad/e-posta/mesaj asla). generate_lead DEĞİL: o, Google Ads'de CRM başvurusudur.
export const trackContactSubmit = (topic) => trackConversion('contact_form_submit', { topic });
